// Real reviews from EasyWorks clients (source: EW reviews.xlsx).
// Each entry keeps the client's verbatim words.

export const realReviews = [
  {
    name: 'Krishna Goswami',
    company: 'Kuber Enterprise',
    initials: 'KG',
    rating: 5,
    category: 'GST Registration',
    quote: 'Great work by Easy Works team! We got our GST registration completed within just 10 days. The team was extremely supportive and kept us informed at every step. Highly professional and efficient service.',
  },
  {
    name: 'Aniket Sharma',
    company: 'ABM International',
    initials: 'AS',
    rating: 5,
    category: 'Multi-state VPOB',
    quote: 'Excellent GST services. I contacted Easy Works for applying for virtual office space in Maharashtra and Karnataka, and the process was handled very professionally and efficiently. The team provided prompt guidance and support throughout. Highly recommended.',
  },
  {
    name: 'Rahul Singh',
    company: 'Ecom Seller',
    initials: 'RS',
    rating: 5,
    category: 'Bihar GST',
    quote: 'We got the Bihar GST. Team Easy Works service was very quick and efficient. The GST was approved within 40 minutes of uploading the documents.',
  },
  {
    name: 'Paras Soni',
    company: 'Qbycon Consumer Brands Pvt Ltd',
    initials: 'PS',
    rating: 5,
    category: 'GST Registration',
    quote: 'The team is really good! They handled everything smoothly and provided us the GST within just 15 days of filing. Really great service and super professional.',
  },
  {
    name: 'Ganesh Kumaran',
    company: 'Fusion Mart',
    initials: 'GK',
    rating: 5,
    category: 'VPOB',
    quote: 'I applied for VPOB with EasyWorks and their process is very smooth. They have a professional CA team to handle the registration. Overall, it was a great experience working with EasyWorks.',
  },
  {
    name: 'Karthiga',
    company: 'Anlage Infotech India Pvt Ltd',
    initials: 'K',
    rating: 5,
    category: 'Compliance',
    quote: 'Easy Works team consistently meets deadlines ahead of schedule, demonstrating strong planning and execution. Akshay\'s support has been particularly commendable, contributing significantly to team efficiency.',
  },
  {
    name: 'Parveen Mehta',
    company: 'RAK Fitness Consumer Pvt Ltd',
    initials: 'PM',
    rating: 5,
    category: 'GST Registration',
    quote: 'Got my GST registration done through EasyWorks. Smooth, fast, and reliable service. Highly recommended!',
  },
  {
    name: 'Anil Choudhary',
    company: 'Someware Appliances Pvt Ltd',
    initials: 'AC',
    rating: 5,
    category: 'Monthly Compliance',
    quote: 'My books are maintained perfectly and on time every month. Easy Works also files my GST regularly and I would recommend them to everyone.',
  },
  {
    name: 'Kamal',
    company: 'Hritvi Enterprise',
    initials: 'K',
    rating: 5,
    category: '8-State VPOB',
    quote: 'I got 8 states of Virtual Office from Easy Works and then had them handle my GST and compliances. I am utterly satisfied with their professionalism and performance of work.',
  },
  {
    name: 'Prajwal Cerejo',
    company: 'Mitchell USA Pvt Ltd',
    initials: 'PC',
    rating: 5,
    category: 'Virtual Office + Accounting',
    quote: 'Easy Works has been an invaluable partner for Mitchell USA. Their exceptional virtual office and accounting services have streamlined our processes and allowed us to focus on our core business.',
  },
];
